import React, { useState } from "react";
import styles from './RootLayout.module.scss'
import AppBar from '@mui/material/AppBar'
import {
  createTheme,
  styled,
  ThemeProvider,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  Box,
  Container
} from "@mui/material"
import { useNavigate, useLocation } from 'react-router-dom';

interface RootLayoutProps {
  children: React.ReactNode;
}

const BglAppBar = styled(AppBar)(({ theme }) => ({
  width: '100%',
  backgroundColor: 'white',
  color: 'black',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid #e0e0e0',
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    minWidth: 120,
  },
}));

const Footer = styled('footer')(({ theme }) => ({
  marginTop: 'auto',
  padding: '16px 0',
  textAlign: 'center',
  borderTop: '1px solid #e0e0e0',
  backgroundColor: '#f5f5f5',
  color: '#666',
}));

export const RootLayout = ({ children }: RootLayoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine current tab based on route
  const getCurrentTab = () => {
    if (location.pathname.includes('/email')) return 0;
    if (location.pathname.includes('/her')) return 1;
    return 0; // default to email
  };

  const [currentTab, setCurrentTab] = useState(getCurrentTab());

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
    if (newValue === 0) {
      navigate('/email-preview');
    } else if (newValue === 1) {
      navigate('/her-preview');
    }
  };

  let theme = createTheme({
    bglPalette: {},
    palette: {
      text: {
        primary: '#000',
        secondary: '#666',
      },
    },
    typography: {
      fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
      fontSize: 14,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className={styles.root}>
        {/* Header with Bidgely Branding */}
        <BglAppBar position="sticky">
          <Toolbar>
            <img
              className={styles.logo}
              src="https://www.bidgely.com/wp-content/themes/bidgely/images/main-logo-small@2x.png"
              alt="Bidgely"
            />
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, fontWeight: 600 }}
            >
              Preview Tool
            </Typography>
          </Toolbar>
        </BglAppBar>

        {/* Navigation Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: 'white' }}>
          <Container maxWidth="xl">
            <StyledTabs
              value={currentTab}
              onChange={handleTabChange}
              aria-label="preview tool navigation"
            >
              <Tab label="Email Preview" />
              <Tab label="HER Preview" />
            </StyledTabs>
          </Container>
        </Box>

        {/* Main Content */}
        <main className={styles.mainCont}>
          <Container maxWidth="xl" sx={{ py: 3 }}>
            {children}
          </Container>
        </main>

        {/* Footer */}
        <Footer>
          <Typography variant="body2">
            Bidgely Internal Use 
          </Typography>
        </Footer>
      </div>
    </ThemeProvider>
  );
};